import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const products = [
  { id: 1, name: "DRAG-ATP", img: "/assets/images/atp.png", price: "$49.99", rating: 4.8, reviews: 124 },
  { id: 2, name: "DRAG-DECA", img: "/assets/images/deca.png", price: "$59.99", rating: 4.9, reviews: 89 },
  { id: 3, name: "DRAG-NPP", img: "/assets/images/npp.png", price: "$54.99", rating: 4.7, reviews: 156 },
  { id: 4, name: "DRAG-PRIMO", img: "/assets/images/primo.png", price: "$69.99", rating: 4.9, reviews: 203 },
];

const FeaturedProducts = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className={`text-center mb-12 md:mb-16 transform transition-all duration-700 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <div className="inline-block">
            <span className="px-4 py-2 bg-gradient-to-r from-amber-50 to-yellow-50 text-yellow-600 rounded-full text-sm font-semibold tracking-wider">
              ✦ FEATURED COLLECTION ✦
            </span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mt-6 leading-tight">
            <span className="bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
              Premium 
            </span>
            <br className="sm:hidden" />
            <span className="bg-gradient-to-r from-red-600 to-red-500 bg-clip-text text-transparent">
              {" "}Featured Products
            </span>
          </h2>
          
          <p className="max-w-3xl mx-auto mt-4 text-sm sm:text-base text-gray-600 leading-relaxed">
            Discover our most comprehensive collection of premium anabolic products. 
            From tablets to injections, we offer the highest quality formulations 
            for your fitness journey.
          </p>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-6 mt-8">
            {[
              { icon: "⚡", text: "Premium Quality" },
              { icon: "💊", text: "Lab Tested" },
              { icon: "🚚", text: "Fast Shipping" },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-gray-600">
                <span className="text-lg">{item.icon}</span>
                <span className="text-xs sm:text-sm font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {products.map((product, index) => (
            <div
              key={product.id}
              className={`group relative transform transition-all duration-500 ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
              onMouseEnter={() => setHoveredId(product.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              {/* Product Card */}
              <div className="relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden">
                
                {/* Image Container */}
                <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 sm:p-8">
                  {/* Discount Badge */}
                  <div className="absolute top-3 left-3 z-10">
                    <span className="px-2 py-1 bg-red-600 text-white text-xs font-bold rounded-full">
                      -15%
                    </span>
                  </div>

                  {/* Wishlist Button */}
                  <button className="absolute top-3 right-3 z-10 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center hover:bg-red-600 group/btn transition-colors">
                    <svg className="w-4 h-4 text-gray-600 group-hover/btn:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                  </button>

                  {/* Product Image with 3D Effect */}
                  <div className="relative flex justify-center">
                    <div className={`absolute inset-0 bg-gradient-to-r from-red-500 to-amber-500 rounded-full blur-2xl opacity-0 group-hover:opacity-20 transition-opacity duration-500`}></div>
                    <img
                      src={product.img}
                      alt={product.name}
                      className={`relative h-40 sm:h-48 w-auto object-contain transform transition-all duration-500 ${
                        hoveredId === product.id ? 'scale-110 rotate-3' : 'scale-100'
                      } drop-shadow-xl`}
                      loading="lazy"
                    />
                  </div>
                </div>

                {/* Product Info */}
                <div className="p-4 sm:p-6">
                  {/* Rating */}
                  <div className="flex items-center gap-2 mb-2">
                    <div className="flex">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} className={`w-4 h-4 ${i < Math.floor(product.rating) ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                    <span className="text-xs text-gray-500">({product.reviews})</span>
                  </div>

                  {/* Product Name */}
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-red-600 group-hover:to-red-500 transition-all duration-300">
                    {product.name}
                  </h3>

                  {/* Price */}
                  <div className="flex items-center gap-2 mt-2">
                    <span className="text-2xl font-bold text-gray-900">{product.price}</span>
                    <span className="text-sm text-gray-400 line-through">$79.99</span>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex gap-2 mt-4">
                    <button className="px-4 py-2 border border-gray-200 text-gray-700 text-sm font-semibold rounded-lg hover:bg-gray-50 transition-colors">
                      Details
                    </button>
                  </div>
                </div>

                {/* Quick View Overlay */}
                <div className={`absolute inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center transition-all duration-300 ${
                  hoveredId === product.id ? 'opacity-100' : 'opacity-0 pointer-events-none'
                }`}>
                  <button className="px-6 py-3 bg-white text-gray-900 font-semibold rounded-lg hover:bg-red-600 hover:text-white transition-colors transform hover:scale-105">
                    Quick View
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className={`text-center mt-12 md:mt-16 transform transition-all duration-700 delay-500 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <Link
            to="/all-products"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-gray-900 to-gray-800 text-white font-semibold rounded-full hover:from-red-600 hover:to-red-500 transition-all duration-300 shadow-lg hover:shadow-xl group"
          >
            <span>View All Products</span>
            <span className="group-hover:translate-x-1 transition-transform">→</span>
          </Link>
        </div>

        {/* Decorative Elements */}
        <div className="hidden lg:block absolute left-0 top-1/3 w-64 h-64 bg-gradient-to-r from-red-100 to-amber-100 rounded-full blur-3xl opacity-20 -z-10"></div>
        <div className="hidden lg:block absolute right-0 bottom-1/3 w-64 h-64 bg-gradient-to-r from-blue-100 to-purple-100 rounded-full blur-3xl opacity-20 -z-10"></div>
      </div>
    </section>
  );
};

export default FeaturedProducts;